import {PercentageBar} from '../../../../../components/barchart/bars/percentage-bar';
import React from 'react';
import {useIntl} from 'react-intl';
import {walletErDetailPageMessages} from 'azshared';
import './residual-duration-chart.scss';
import {Loader, LoaderSize} from '../../../../../components/loader/loader';
import {ResidueDuration} from 'azshared/build/main/lib/model/wallet/wallet-ow';

export interface ResidualDurationChartProps {
  residueDuration:  ResidueDuration,
  isLoading: boolean,
}

export const ResidualDurationChart = (props: ResidualDurationChartProps) => {
  const {formatMessage} = useIntl();
  const {residueDuration, isLoading} = props;


  return (
    <div className={'residual-duration-chart'}>
      <h4>{formatMessage(walletErDetailPageMessages.productExpirationDateTitle)}</h4>
      <div className={'residual-duration-content' + (isLoading ? '-loader' : '')}>
        {isLoading && <Loader loadersize={LoaderSize.XL}/>}
        {!isLoading && residueDuration.products.length === 0 && (
          <div style={{marginTop: 120}}>
            <p className={'empty-wallet'}>{formatMessage(walletErDetailPageMessages.residualDurationChartEmpty)}</p>
          </div>
        )}
        {!isLoading && residueDuration.products.map((p, i) =>
          <PercentageBar
            key={'residual-duration-chart-percentage_' + i}
            percentage={p.expirationPercentage}
            title={p.description}
            start={0}
            end={p.years}
            disabled={p.years === 0}
            step={1}
            xLegend={p.years === 0 ? undefined : formatMessage(walletErDetailPageMessages.productYears)}
            yLegend={p.years === 0 ? formatMessage(walletErDetailPageMessages.productND) : formatMessage(walletErDetailPageMessages.productLabel)}
          />
        )}
      </div>
    </div>
  );
};